/**
 * CSV export: column ordering helpers.
 * For Media Devoted | Created By Ciro Autiero
 */

/**
 * Build export column order: preserve `desiredOrder` (filtered to spec), then append any
 * spec keys missing from the template (new columns) in spec order.
 */
export function normalizeExportColumnOrder(
  specKeys: readonly string[],
  desiredOrder: readonly string[],
): string[] {
  const allow = new Set(specKeys);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const k of desiredOrder) {
    if (!allow.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  for (const k of specKeys) {
    if (seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}

/** @deprecated Prefer normalizeExportColumnOrder + explicit ordered selection for user-controlled order. */
export function orderedSelectedColumnKeys(
  columnSpecs: readonly { key: string }[],
  selectedKeys: unknown,
): string[] {
  const keys = Array.isArray(selectedKeys)
    ? selectedKeys.filter((k): k is string => typeof k === "string")
    : [];
  const selected = new Set(keys);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const c of columnSpecs) {
    const k = c.key;
    if (!selected.has(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}
